import { $t } from "@/lib/i18nHelpers";
import { PurchaseType } from "@/const";

export interface PaymentConfirmationData {
  fromBalance: boolean;
  paymentSystemId?: string;
}

export const purchaseTypeNames = {
  [PurchaseType.TOP_UP]: $t("Top up"),
  [PurchaseType.ONE_TIME]: $t("One time buy"),
  [PurchaseType.ONE_TIME_BALANCE]: $t("One time buy"),
  [PurchaseType.SUBSCRIPTION]: $t("Subscription"),
};
